import { classes } from 'html-classes';
import { forwardRef } from 'react';

import Icon from '~/components/Icon/Icon';

import { SIZE, SizeMap, VARIANT, VariantMap } from './constants';
import { SimpleInputProps } from './interfaces';
import styles from './SimpleInput.module.scss';

const SimpleInput = forwardRef<HTMLInputElement, SimpleInputProps>(
  (
    {
      variant = VARIANT.primary,
      size = SIZE.M,
      className,
      inputClassName,
      clearable = false,
      onClear,
      value,
      ...props
    },
    ref,
  ) => {
    const showClearButton = clearable && value;

    const handleClear = () => {
      if (onClear) {
        onClear();
      }
    };

    return (
      <div
        className={classes([
          styles.wrapper,
          VariantMap.get(variant),
          SizeMap.get(size),
          className,
        ])}
      >
        <input
          {...props}
          ref={ref}
          className={classes([styles.input, inputClassName])}
          value={value}
        />

        {showClearButton && (
          <button
            type="button"
            className={styles.clearButton}
            onClick={handleClear}
          >
            <Icon type="close" size={16} />
          </button>
        )}
      </div>
    );
  },
);

SimpleInput.displayName = 'SimpleInput';

export default SimpleInput;
